import { Button } from "@components/ui/button"
import { DataTable } from "@components/DataTable/DataTable"
import { useAccountOfferFunnel } from "@components/AccountNew/OfferFunnel/utils/useAccountOfferFunnel"
import { useChooseOfferColumns } from "@components/AccountNew/OfferFunnel/utils/tableColumnSchema"
import { useOffersSerializer } from "@components/AccountNew/OfferFunnel/utils/useOffersSerializer"
import { OFFER_TYPES } from "@apis/offers/types"

export const ChooseOffer = () => {
  const { data, isPending, isError, error } = useOffersSerializer()
  const { setStep, eligibleOfferType } = useAccountOfferFunnel()

  const chooseOfferColumns = useChooseOfferColumns()

  const ineligibleMessage =
    eligibleOfferType === OFFER_TYPES.Retention
      ? "This member has no retention offers available on the account. The member may continue on their existing plan, or elect to cancel."
      : "This member has no winback offers available on the account. The member cannot be wonback."

  return (
    <div className="tw:flex tw:flex-col tw:gap-4">
      <h4 className="tw:text-xl tw:font-semibold">
        {eligibleOfferType} Offers
      </h4>
      {isError ? (
        <div className="tw:py-4 tw:text-red-500">
          Error loading {eligibleOfferType} offers. {error?.message}
        </div>
      ) : (
        <>
          {data?.path?.path_type?.toUpperCase() === "INELIGIBLE" ? (
            <p>{ineligibleMessage}</p>
          ) : (
            <DataTable
              columns={chooseOfferColumns}
              data={data?.eligible_offers ?? []}
              pending={isPending}
              noResultsMessage={"No offers available at this time."}
            />
          )}

          {data && <p className="tw:px-1">Request Id: {data.requestId}</p>}
        </>
      )}

      <div className="tw:flex tw:justify-between">
        <Button variant="outline" onClick={() => setStep("initial")}>
          Go Back
        </Button>
        {eligibleOfferType === OFFER_TYPES.Retention && (
          <Button variant="destructive" onClick={() => setStep("cancelMember")}>
            Cancel Account
          </Button>
        )}
      </div>
    </div>
  )
}
